import Table from "@/components/shared/Table";
import { useTranslation } from "react-i18next";

function Scales() {
  const { t } = useTranslation();
  const probabilityScale = [
    {
      GenericTitle: t("GenericTitle1"),
      QuantitativeData: t("QuantitativeData1"),
      QualitativeData: t("QualitativeData1"),
    },
    {
      GenericTitle: t("GenericTitle2"),
      QuantitativeData: t("QuantitativeData2"),
      QualitativeData: t("QualitativeData2"),
    },
    {
      GenericTitle: t("GenericTitle3"),
      QuantitativeData: t("QuantitativeData3"),
      QualitativeData: t("QualitativeData3"),
    },
    {
      GenericTitle: t("GenericTitle4"),
      QuantitativeData: t("QuantitativeData4"),
      QualitativeData: t("QualitativeData4"),
    },
  ];

  const impactScale = [
    {
      Level: t("Level1"),
      BriefDescription: t("Description1"),
    },
    {
      Level: t("Level2"),
      BriefDescription: t("Description2"),
    },
    {
      Level: t("Level3"),
      BriefDescription: t("Description3"),
    },
    {
      Level: t("Level4"),
      BriefDescription: t("Description4"),
    },
  ];

  return (
    <div className="p-4 h-full overflow-auto">
      <div className="w-3/5">
        <div className="w-full text-center p-2 bg-primary-500 text-white ">
          {t("Frequency/Probability Scale")}
        </div>
        <Table
          className="!px-0"
          data={probabilityScale}
          hederClassName={"!bg-primary-500/30 !text-primary-500 !font-semibold [&>*]:select-auto"}
          columnDef={[
            { header: t("Generic Title"), key: "GenericTitle",  className: () => {return "text-start [&>*]:block";} },
            { header: t("Quantitative Data"), key: "QuantitativeData",className: () => {return "text-start [&>*]:block";}    },
            { header: t("Qualitative Data"), key: "QualitativeData",className: () => {return "text-start [&>*]:block";}   },
          ]}
          hidePagination={true}
        ></Table>
      </div>
      <div className=" mt-5">
        <div className="w-full text-center p-2 bg-primary-500 text-white ">
          {t("Impact Scale")}
        </div>
        <Table
          className="!px-0"
          data={impactScale}
          hederClassName={"!bg-primary-500/30 !text-primary-500 !font-semibold  [&>*]:select-auto"}
          columnDef={[
            {
              header: t("Levels"),
              key: "Level",
              className: () => {
                return "w-52";
              },
            },
            {
              header: t("Brief Description"),
              key: "BriefDescription",
              className: () => {
                return "[&>*]:justify-start";
              },
            },
          ]}
          hidePagination={true}
        ></Table>
      </div>
    </div>
  );
}

export default Scales;
